import React, { memo } from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as searchFiltersSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import {
  effects as searchPageEffects,
  selectors as searchPageSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import {
  actions as searchActions,
  selectors as searchSelectors,
} from '@rover/react-lib/src/redux/ducks/search.duck';
import { selectors as serviceTypeSelectors } from '@rover/react-lib/src/redux/ducks/serviceTypes.duck';

import BooleanFiltersModal from './BooleanFiltersModal';

export type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const effects = {
  updateFiltersAndFireSearchOnChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
};

const actions = {
  toggleIsShowingPriceInCurrency: searchActions.toggleIsShowingPriceInCurrency,
};

const selector = (state) => {
  const queryDerivedData = searchSelectors.getQueryDerivedData(state);
  const searchFilters = searchFiltersSelectors.getFilters(state);
  const serviceTypeFilterOptions = searchFiltersSelectors.getServiceTypeFilterOptions(state);
  const isIncludingFees = serviceTypeFilterOptions.minprice?.fullprice === true;
  const getPriceUnit = serviceTypeSelectors.getPriceUnit(state);

  return {
    searchFilters,
    serviceTypeFilterOptions,
    countryCode: searchSelectors.getSearchCountryCode(state),
    isShowingPriceInCurrency: searchSelectors.getIsShowingPriceInCurrency(state),
    priceFilterProps: {
      currencyCode: searchSelectors.getSearchCurrencyCode(state),
      isStaffOrImpersonating: currentUserSelectors.isStaffOrImpersonating(state),
      locale: frontendConfigurationSelectors.getLanguage(state),
      priceUnit: getPriceUnit(searchFilters.serviceType),
      priceFilterMinValue: searchPageSelectors.getPriceFilterMinValue(state),
      priceFilterMaxValue: searchPageSelectors.getPriceFilterMaxValue(state),
      isIncludingFees,
    },
    queryDerivedData,
  };
};

const BooleanFiltersModalContainer = (props: Props): JSX.Element => (
  <Connect selector={selector} effects={effects} actions={actions}>
    {(connectedProps) => <BooleanFiltersModal {...connectedProps} {...props} />}
  </Connect>
);

export default memo(BooleanFiltersModalContainer);
